(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feds-federal-directory"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('feds-federal-directory')) {
customElements.define('feds-federal-directory',class extends HTMLElement {
connectedCallback(){
if(this.bound)return;this.bound=true;
this.querySelectorAll('[data-group]').forEach(group=>{
const slider=group.querySelector('.fd-grid'),prev=group.querySelector('[data-prev]'),next=group.querySelector('[data-next]');
if(!prev||!next)return;
const update=()=>{prev.disabled=slider.scrollLeft<=2;next.disabled=slider.scrollLeft+slider.clientWidth>=slider.scrollWidth-2;};
const move=direction=>slider.scrollBy({left:direction*slider.clientWidth*.9,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
slider.addEventListener('scroll',update,{passive:true});group.addEventListener('toggle',()=>requestAnimationFrame(update));
const observer=new ResizeObserver(update);observer.observe(slider);(this.observers||=[]).push(observer);update();
});
this.addEventListener('shopify:block:select',event=>{const group=event.target.closest('[data-group]');if(group)group.open=true;});
}
disconnectedCallback(){(this.observers||[]).forEach(o=>o.disconnect());}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feds-government-navigation"] && !Shopify.designMode) return;
  try {
    
if (!window.fedsGovernmentNavigationBound) {
  window.fedsGovernmentNavigationBound = true;
  document.addEventListener('click', (event) => {
    const root = event.target.closest('[data-government-nav]');
    document.querySelectorAll('[data-government-nav]').forEach((nav) => {
      if (nav !== root) {
        nav.querySelectorAll('details[open]').forEach((item) => item.open = false);
        nav.dataset.open = 'false';
        nav.querySelector('button').setAttribute('aria-expanded','false');
      }
    });
    if (!root) return;
    const toggle = event.target.closest('.feds-government__toggle');
    if (toggle) {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      root.dataset.open = String(open);
    }
    const summary = event.target.closest('summary');
    if (summary) root.querySelectorAll('details[open]').forEach((item) => {
      if (item !== summary.parentElement) item.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const root = event.target.closest('[data-government-nav]');
    if (!root) return;
    const open = root.querySelector('details[open]');
    if (open) {
      open.open = false;
      open.querySelector('summary').focus();
    } else {
      root.dataset.open = 'false';
      const toggle = root.querySelector('button');
      toggle.setAttribute('aria-expanded','false');
      toggle.focus();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feds-policy-content"] && !Shopify.designMode) return;
  try {
    
function organizePolicy(root){
 const source=root.querySelector('[data-policy-source]');if(!source||source.dataset.organized)return;
 const topics=root.querySelector('[data-policy-topics]');const sections=root.querySelector('[data-policy-sections]');
 const nodes=Array.from(source.childNodes);let detail=null,count=0;
 for(const node of nodes){
  const text=(node.textContent||'').trim();
  const heading=node.nodeType===1&&(/^H[2-4]$/.test(node.tagName)||(node.tagName==='P'&&Array.from(node.children).every(e=>['STRONG','BR'].includes(e.tagName))&&node.querySelector('strong')?.textContent.trim()===text&&text.length<160));
  if(heading){
   count++;const article=document.createElement('article');article.className='feds-body__topic';article.id=root.closest('[id]').id+'-topic-'+count;
   const grid=document.createElement('div');grid.className='container feds-body__grid';
   const title=document.createElement('div');title.className='feds-body__title';
   const num=document.createElement('span');num.className='feds-body__number';num.setAttribute('aria-hidden','true');num.textContent=String(count).padStart(2,'0');
   const h=document.createElement('h2');h.textContent=text;title.append(num,h);
   detail=document.createElement('div');detail.className='feds-body__detail rte';grid.append(title,detail);article.append(grid);sections.append(article);
   const a=document.createElement('a');a.href='#'+article.id;a.textContent=text;topics.append(a);node.remove();
  }else if(detail){detail.append(node);}
 }
 source.dataset.organized='true';if(!source.textContent.trim())source.remove();
}
document.querySelectorAll('[data-policy-document]').forEach(organizePolicy);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-policy-document]').forEach(organizePolicy));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feds-polo-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('feds-product-story')){
  customElements.define('feds-product-story',class extends HTMLElement{
    connectedCallback(){
      this.controller=new AbortController();
      const signal=this.controller.signal;
      this.querySelectorAll('.fe-carousel').forEach(carousel=>{
        const track=carousel.querySelector('.fe-product-track');
        const previous=carousel.querySelector('[data-direction="-1"]');
        const next=carousel.querySelector('[data-direction="1"]');
        const update=()=>{previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};
        carousel.querySelectorAll('[data-direction]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.direction)*track.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}),{signal}));
        track.addEventListener('scroll',update,{signal,passive:true});
        window.addEventListener('resize',update,{signal});
        update();
      });
      const thumbs=document.querySelector('.product-main .media-thumbs');
      if(thumbs){
        this.observer=new MutationObserver(()=>{
          if(!matchMedia('(min-width:1024px)').matches)return;
          const active=thumbs.querySelector('[aria-current="true"]');
          if(active){const box=active.getBoundingClientRect(),rail=thumbs.getBoundingClientRect();if(box.top<rail.top||box.bottom>rail.bottom)thumbs.scrollTo({top:thumbs.scrollTop+box.top-rail.top,behavior:'smooth'})}
        });
        this.observer.observe(thumbs,{subtree:true,attributes:true,attributeFilter:['aria-current']});
      }
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feds-store-directory-menu"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('feds-directory-navigation')){
customElements.define('feds-directory-navigation',class extends HTMLElement{
connectedCallback(){
if(this.bound)return;this.bound=true;
const toggle=this.querySelector('button');
const setOpen=open=>{this.dataset.faMobileNavOpen=String(open);toggle.setAttribute('aria-expanded',String(open));};
toggle.addEventListener('click',()=>setOpen(toggle.getAttribute('aria-expanded')!=='true'));
this.addEventListener('keydown',event=>{if(event.key==='Escape'){setOpen(false);toggle.focus();}});
this.querySelector('nav').addEventListener('click',event=>{if(event.target.closest('a'))setOpen(false);});
}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
